import { alpha, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdRefresh } from "react-icons/md";

interface ResetButtonProps {
  onClick: () => void;
  label?: string;
}

export const ResetButton = ({ onClick, label }: ResetButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="text"
      size="small"
      startIcon={<MdRefresh size={16} />}
      onClick={onClick}
      sx={{
        color: "text.secondary",
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
          color: "primary.main",
        },
      }}
    >
      {label ?? t("preferences.uiBranding.resetToDefault")}
    </Button>
  );
};
